<template>
    <div class="exam-result-management">
        <h3> 계정관리 > 상세</h3>
        <div class="account-card-box">
            <h2 class="register-title">{{ isEditMode ? '계정 수정' : '계정 등록' }}</h2>

            <form class="register-form" @submit.prevent="submitAccount">
                <div class="form-row" v-if="form.level ===  1">
                    <label class="form-label" for="hospital">소속</label>
                    <select v-model="form.hospital" id="hospital" class="form-inp">
                        <option disabled value="">선택하세요</option>
                        <option value="0">서울대학교병원</option>
                        <option value="1">강남세브란스</option>
                        <option value="2">삼성서울병원</option>
                    </select>
                </div>
                <div class="form-row">
                    <label class="form-label" for="name">이름</label>
                    <input v-model="form.name" id="name" required class="form-inp" placeholder="이름" />
                </div>
                <div class="form-row">
                    <label class="form-label" for="email">이메일</label>
                    <!-- <input v-model="form.email" id="email" required class="form-inp" placeholder="이메일" :readonly="isEditMode"/> -->
                    <input
                        v-model="form.email"
                        id="email"
                        class="form-inp"
                        placeholder="이메일"
                        :readonly="isEditMode"
                        autocomplete="off"
                    />
                </div>

                <div class="form-row">
                    <label class="form-label" for="password">비밀번호</label>
                    <!-- <input v-model="form.password" id="password" type="password" class="form-inp" placeholder="새 비밀번호(수정 시만 입력, 비워두면 기존 유지)" /> -->
                    <input
                        v-model="form.password"
                        id="password"
                        type="password"
                        class="form-inp"
                        placeholder="새 비밀번호(수정 시만 입력, 비워두면 기존 유지)"
                        autocomplete="new-password"
                    />
                </div>
                <div class="form-row">
                    <label class="form-label" for="passwordConfirm">비밀번호 확인</label>
                    <!-- <input v-model="form.passwordConfirm" id="passwordConfirm" type="password" class="form-inp" placeholder="새 비밀번호(수정 시만 입력, 비워두면 기존 유지)" /> -->
                    <input
                        v-model="form.passwordConfirm"
                        id="passwordConfirm"
                        type="password"
                        class="form-inp"
                        placeholder="새 비밀번호(수정 시만 입력, 비워두면 기존 유지)"
                        autocomplete="new-password"
                    />
                </div>
                <div class="form-row">
                    <label class="form-label" for="phone">전화번호</label>
                    <input v-model="form.phone" id="phone" type="text" required class="form-inp" placeholder="전화번호 입력" />
                </div>
                <div class="form-row">
                    <label class="form-label" for="hospitalCode">병원 코드</label>
                    <input v-model="form.hospitalCode" id="hospitalCode" type="text" required class="form-inp" placeholder="병원 코드 입력" />
                </div>
                <div class="form-row">
                    <label class="form-label" for="isActive">활성화 여부</label>
                    <select v-model="form.isActive" id="isActive" class="form-inp">
                        <option value="Y">활성화</option>
                        <option value="N">비활성화</option>
                    </select>
                </div>
                <div class="form-row">
                    <label class="form-label" for="status">승인상태</label>
                    <select v-model.number="form.status" id="status" class="form-inp">
                        <option :value="0">승인 대기중</option>
                        <option :value="1">승인 완료</option>
                    </select>
                </div>
                <div class="form-actions">
                    <button class="account-btn account-btn--register" type="submit">
                        {{ isEditMode ? '수정' : '등록' }}
                    </button>
                    <button class="account-btn account-btn--edit" type="button" @click="goList">목록</button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import api, {urls} from '@/api'


export default {
    name: "AccountRegister",
    meta: {
        title: "사용자 관리"
    },
    // data() {
    //     return {
    //         form: {
    //             name: "",
    //             email:"",
    //             phone: "",
    //             hospitalCode: "",
    //             isActive: "Y",    // 예) 'Y' or 'N'
    //             status: 1,        // 0: 대기, 1: 승인, 2: 정지
    //         },
    //         isEditMode: false,
    //         password: '',
    //         passwordConfirm: '',
    //     };
    // },
    data() {
        return {
            form: this.getDefaultForm(),
            isEditMode: false,
        }
    },
    methods: {
        validateForm() {
            // 이름 비어있음 확인
            if (!this.form.name || this.form.name.trim() === "") {
                alert("이름을 입력해주세요.");
                return false;
            }

            // 이메일 비어있음 확인
            if (!this.form.email || this.form.email.trim() === "") {
                alert("이메일을 입력해주세요.");
                return false;
            }

            // 전화번호 형식 체크 (하이픈 제거 후 9~11자리 숫자)
            const phoneDigits = this.form.phone.replace(/-/g, "");
            if (!/^\d{9,11}$/.test(phoneDigits)) {
                alert("전화번호를 올바른 형식으로 입력해주세요. (9~11자리 숫자)");
                return false;
            }

            // 병원 코드 비어있음 확인
            if (!this.form.hospitalCode || this.form.hospitalCode.trim() === "") {
                alert("병원 코드를 입력해주세요.");
                return false;
            }

            // 모든 체크 통과
            return true;
        },
        submitAccount() {
            if (!this.validateForm()) {
                return // 검증 실패 시 제출 막기
            }

            const url = this.isEditMode ? urls.account.modify : urls.account.register
            if (this.form.password || this.form.passwordConfirm) {
                if (this.form.password !== this.form.passwordConfirm) {
                    alert('비밀번호와 비밀번호 확인이 일치하지 않습니다.');
                    return;
                }
                if (!this.isValidPassword(this.form.password)) {
                    alert('비밀번호는 영문, 숫자, 특수문자를 포함하여 8자 이상이어야 합니다.');
                    return;
                }
            }

            if (this.form.password && this.form.passwordConfirm) {
                if (this.form.password !== this.form.passwordConfirm) {
                    alert('비밀번호와 비밀번호 확인이 일치하지 않습니다.');
                    return;
                }
                // 비밀번호가 일치하면 요청 데이터에 추가
                this.form.password = this.form.password;
            }

            api.post(url, this.form)
                .then(res => {
                    if (res.data === 1) {
                        alert(this.isEditMode ? '계정 수정이 완료되었습니다.' : '계정 등록이 완료되었습니다.')
                        this.goList()
                    } else {
                        alert(res.data.message || (this.isEditMode ? '계정 수정에 실패했습니다.' : '계정 등록에 실패했습니다.'))
                    }
                })
                .catch(e => {
                    alert(this.isEditMode ? '계정 수정 처리 중 오류가 발생했습니다.' : '계정 등록 처리 중 오류가 발생했습니다.')
                    console.error(e)
                })
        },
        loadAccountForEdit(id) {
            api.get(urls.account.userData, { params: { id: id } })
                .then(res => {
                    const data = res.data.list && res.data.list[0]
                    if (data) {
                        this.isEditMode = true
                        this.form = {
                            id: data.id || '',
                            hospital: Number(data.hospital) || 0,
                            name: data.name || '',
                            userId: data.userId || '',
                            email: data.email || '',
                            password: '',
                            passwordConfirm: '',
                            phone: data.phone || '',
                            hospitalCode: data.inst_cd || '',
                            dept: Number(data.dept) || 0,
                            position: Number(data.position) || 0,
                            workRole: Number(data.role) || 0,
                            level: data.level || '',
                            isActive: data.is_active || 'N',
                            status: Number(data.status) || 0,
                        }
                    }
                })
                .catch(e => {
                    alert('계정 정보 불러오기에 실패했습니다.')
                    console.error(e)
                })
        },
        goList() {
            this.$router.push('/account/UserManagement')   // 등록 모드에는 사용자 관리 페이지로
        },
        // 비밀번호 형식 검사 정규식 (영문, 숫자, 특수문자 포함, 8자 이상)
        isValidPassword(password) {
            if (!password) return true; // 비밀번호 미입력 시 검사 통과 (수정 시 선택 사항)
            const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[~!@#%^&*_-])[A-Za-z\d~!@#%^&*_-]{8,}$/
            return passwordRegex.test(password);
        },

        getDefaultForm() {
            return {
                hospital: "",
                name: "",
                email: "",
                password: "",
                passwordConfirm: "",
                phone: "",
                hospitalCode: "",
                level: "",
                isActive: "Y",
                status: 1,
            }
        }

    },
    // mounted() {
    //     const id = this.$route.query.id;
    //     if (id !== undefined) {
    //         // 수정 모드일 때
    //         this.loadAccountForEdit(id);
    //     }
    // }
    mounted() {
        const id = this.$route.query.id;

        if (id !== undefined) {
            this.loadAccountForEdit(id);
        } else {
            this.isEditMode = false;
            this.form = this.getDefaultForm();

            // 🔥 등록 모드일 때 이메일, 비밀번호 명시적 초기화
            this.form.email = "";
            this.form.password = "";
            this.form.passwordConfirm = "";
        }
    }
};
</script>
